// dependencies
import { useState, useEffect } from "react";
// api
import { getAllProjects, getTop3Projects, getProjectById, addDocument, deleteDocument, deleteFolder } from "../api/firebase/firebase";


// === READ === //

// fetch all projects with api call
export const useFetchProjects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProjects = async () => {
        try {
            setLoading(true);
            const data = await getAllProjects();
            setProjects(data);
        } catch (err) {
            console.error(err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    return { projects, loading, error, refetch: fetchProjects };
};

// fetch top 3 projects with api call
export const useFetchTop3Projects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProjects = async () => {
        try {
            setLoading(true);
            const data = await getTop3Projects();
            setProjects(data);
        } catch (err) {
            console.error(err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    return { projects, loading, error };
};

// fetch single project with api call
export const useFetchProjectById = (id) => {
    const [project, setProject] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProject = async () => {
        try {
            setLoading(true);
            const data = await getProjectById(id);
            setProject(data);
        } catch (err) {
            console.error(err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProject();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return { project, loading, error, refetch: fetchProject };
};
// ================ //



// === CREATE === //
//? could maybe refactor this to handle loading and error and then use
/**
 * add a document to a collection with firebase API func
 * @param {string} collectionName name of the firestore collection
 * @param {Object} data object with the data to be added
 */
export const useAddDocument = (collectionName, data) => {

    useEffect(() => {
        const addDoc = async () => {
            await addDocument(collectionName, data);
        };
        addDoc();
    }, [collectionName, data]);
};
// ================ //





// === DELETE === //
/**
 * delete a project from Firestore and Firebase Storage
 * @returns {{
 *   deleteProject: (id: string, projectTitle: string, storage: any) => Promise<void>
 * }}
 */
export const useDeleteProject = () => {
    /**
     * deletes a project: Firestore doc and Storage folder
     * @param {string} id - ID of the Firestore document
     * @param {string} projectTitle - Folder name in storage
     * @param {any} storage - Firebase storage instance
     * @returns {Promise<void>}
     */
    const deleteProject = async (id, projectTitle, storage) => {
        // delete project folder contents including images and thumbnail
        await deleteFolder(storage, `images/${projectTitle}`);

        await deleteDocument("projects", id)
    };

    return { deleteProject };
};


// ================ //


